<app-purple-api-error-wrapper [enabledErrorPages]="enableErrorPages" [loaderId]="loaderId" [reqConditions]="(tsvc.isInitialized | async)"></app-purple-api-error-wrapper>

<purple-loader height="600px" loaderPath="/assets/loaders/main-loader.json" [loaderId]="loaderId"></purple-loader>